// extracted by mini-css-extract-plugin
export default {"container":"FocusedEntity_container__h3X5N","description":"FocusedEntity_description__-CyOJ"};